$(document).ready(function() {
  document.body.style.setProperty('--device-height', `${window.innerHeight - document.querySelector('#shopify-section-header').clientHeight}px`);

  $('.announcement-bar-slider').on('init', () => {
    document.body.style.setProperty('--device-height', `${window.innerHeight - document.querySelector('#shopify-section-header').clientHeight}px`);
  });

  $('.announcement-bar-slider').slick({
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 4000,
    infinity: true,
    fade: false,
    speed: 0
  })

  const hideAnnoucementBar = () => {
    const announcementBar = document.querySelector('.announcementBar');

    announcementBar?.classList.add('announcementBar--hidden');
    document.body.style.setProperty('--device-height', `${window.innerHeight - document.querySelector('#shopify-section-header').clientHeight}px`);
  };

  const announcementBarCloseButton = document.querySelector('.announcementBar__close');

  announcementBarCloseButton.addEventListener('click', hideAnnoucementBar);
});